import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { JudgePhaseProjectDocumentType } from "../../../types/ScientificModule";

const initialState: JudgePhaseProjectDocumentType = {
    id: "",
    docBase64: "",
    idJudgePhaseProject: "",
    status: false,
};

const judgePhaseProjectDocumentsSlice = createSlice({
    name: "judgePhaseProjectDocuments",
    initialState,
    reducers: {
        setJudgePhaseProjectDocumentsData: (
            state,
            action: PayloadAction<JudgePhaseProjectDocumentType>
        ) => ({ ...state, ...action.payload }),
        resetJudgePhaseProjectDocumentsData: () => ({ ...initialState }),
    },
});

export const {
    setJudgePhaseProjectDocumentsData,
    resetJudgePhaseProjectDocumentsData,
} = judgePhaseProjectDocumentsSlice.actions;

export default judgePhaseProjectDocumentsSlice.reducer;
